export const GetContactInfo = () => {
    return (
        [{"id":1,"name":"Location","value":"1112 E. Copeland Road, Suite 200 Arlington, TX 76011"},{"id":2,"name":"Phone Number","value":"817-785-0090"}]
    )
}